import { combineReducers } from 'redux';
import config from './modules/config';
import i18n from './modules/i18n';
import partner from './modules/partner';
import overlayLoader from './modules/overlay-loader';
import errors from './modules/errors';

const rootReducer = combineReducers({
  locale: i18n.reducers.locale,
  config: config.reducers.serviceConfig,
  partner: partner.reducers.partnerData,
  ui: combineReducers({
    overlayLoader: combineReducers({
      message: overlayLoader.reducers.message,
    }),
    errors: combineReducers({
      errorMessage: errors.reducers.errorMessage,
    }),
  }),
});

export default rootReducer;
